import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SalesRoutingModule } from './sales-routing.module';
import { VentasComponent } from './ventas/ventas.component';
import { ButtonModule } from 'primeng/button';
import { RadioButtonModule } from 'primeng/radiobutton';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { InputNumberModule } from 'primeng/inputnumber';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
//import { FooterComponent } from '../resources/footer/footer.component';
import { InputTextModule } from 'primeng/inputtext';
import { QrCodeModule } from 'ng-qrcode';
import { VentasAcumuladasComponent } from './ventas-acumuladas/ventas-acumuladas.component';
import { TreeModule } from 'primeng/tree';
import { TreeTableModule } from 'primeng/treetable';
import { DividerModule } from 'primeng/divider';
import { SidebarModule } from 'primeng/sidebar';
import { PanelMenuModule } from 'primeng/panelmenu';
import { ResourcesModule } from '../resources/resources.module';
import { CardModule } from 'primeng/card';
import { NgApexchartsModule } from 'ng-apexcharts';
import { CancelarVentaComponent } from './cancelar-venta/cancelar-venta.component';
import { ConsultaTicketComponent } from './consulta-ticket/consulta-ticket.component';
import { ReciboComponent } from './recibo/recibo.component';
import { AsignacionVendedorComponent } from './asignacion-vendedor/asignacion-vendedor.component';
import { LiquidacionRegistroComponent } from './liquidacion-registro/liquidacion-registro.component';
import { SeguimientoComponent } from './seguimiento/seguimiento.component';
import { TabViewModule } from 'primeng/tabview';
import { AccordionModule } from 'primeng/accordion';
import { SelectModule } from 'primeng/select';
import { DatePickerModule } from 'primeng/datepicker';



@NgModule({
  declarations: [VentasComponent, VentasAcumuladasComponent,
    CancelarVentaComponent,
    ConsultaTicketComponent, ReciboComponent,
    AsignacionVendedorComponent, LiquidacionRegistroComponent, SeguimientoComponent],
  imports: [
    CommonModule,
    SalesRoutingModule,
    FormsModule,
    ButtonModule,
    RadioButtonModule,
    AutoCompleteModule,
    InputNumberModule,
    InputTextModule,
    SelectModule,
    DialogModule,
    ToastModule,
    ReactiveFormsModule,
    SidebarModule,
    PanelMenuModule,
    QrCodeModule,
    TreeModule,
    TreeTableModule,
    DividerModule,
    ResourcesModule,
    CardModule,
    TabViewModule,
    NgApexchartsModule, AccordionModule,DatePickerModule
  ],
  exports: []
})
export class SalesModule { }
